/**
 * @module Components.StripeForm
 *
 */
import React from "react";
import AnalyzeCheckoutFormWrapper, {
  PropsDef,
} from "./AnalyzeCheckoutFormWrapper";

export default function StripeForm(props: PropsDef) {
  return <AnalyzeCheckoutFormWrapper {...props} />;
}
